import React, { useEffect, useMemo, useState, useCallback } from "react"

import TableContainer from "../Table/TableContainer"

import { HandleResponse } from '../../handleResponse';
import { Config } from '../../config';
import { Button } from 'react-bootstrap';

import { useNavigate } from 'react-router-dom';
import { fetchWithCredentials } from '../../Authentication';

async function fetchPagesAsync() 
{
    const response = await fetchWithCredentials(Config.apiUrl + "/person/",
            {
                method: 'GET',
            })

     return await HandleResponse(response);
}

async function deleteAsync(id) 
{
    const response = await fetchWithCredentials(Config.apiUrl + '/persons/' + id,
        {
            method: 'DELETE',
        })

        return await HandleResponse(response);
} 

export default function AdminPersonTable()
{
    const [data, setData] = useState([])
    const navigate  = useNavigate();

    useEffect(() => 
    { // component did mount replacement
        console.log("useEffect called");

      const doFetch = async () => {
        const contacts = await fetchPagesAsync().catch(error => console.log("error: " + error));
        setData(contacts)
      }
      doFetch()
    }, [])

    const EditPerson = useCallback ((props) =>
    {
        navigate('/admin/person/' + props.row.values.id, { replace: true });
    }, [navigate]);

    const DeletePerson = useCallback (async (props) =>
    {
        await deleteAsync(props.row.values.id);
        navigate('/admin/persons/', { replace: true });
    }, [navigate]);

    const columns = useMemo(
        () => [
            {
                Header: "Id",
                accessor: "id",
                Cell: row => <div style={{ textAlign: "right"}}>{row.value}</div>,
            },
            {
                Header: "Email",
                accessor: "email",
                minWidth: 100,
                width: 450,
                maxWidth: 600
            },
            {
                Header: "Name",
                accessor: "name",
                minWidth: 100,
                width: 450,
                maxWidth: 600
            },
            {
                Header: " ",
                Cell: (props) => <Button variant="secondary" onClick=
                {
                    () => EditPerson(props, navigate)
                } 
                >EDIT</Button>,
                minWidth: 100,
                width: 100,
                maxWidth: 100,
                isResizing: false
            },
            {
                Header: "  ",
                Cell: (props) => <Button variant="secondary" onClick=
                {
                    () => DeletePerson(props, navigate)
                } 
                >X</Button>,
                minWidth: 50,
                width: 50,
                maxWidth: 50,
                isResizing: false
            }
        ],
        [navigate, DeletePerson, EditPerson]
    )
  
    return <TableContainer columns={columns} data={data} width="100%"/>;
  }
